<template>
  <div> 
<md-card class="searchPanel">
  <md-card-content v-if="searchRequest">
      <div class="md-layout md-gutter">

        <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div ref = "refapptDateF" class = "inputBox">
            <datepicker v-model="searchRequest.apptDate.startDate">
              <label>Appt date</label>
            </datepicker>
          </div>
        </div>

        <!-- <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div ref = "refapptDateT" class = "inputBox">
            <datepicker v-model="searchRequest.apptDate.endDate">
              <label>To</label>
            </datepicker>
          </div>
        </div> -->

        <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div class = "inputBox">
          <auto-complete-master-data-select
                                              group="REC_WINDOW"
                                              label="Rev. Windows"
                                              :preparedOptions="inbound_recwin"
                                              :init-value="searchRequest.receivingWindows"
                                              :on-item-changed="handleWindowsChanged"
                                              >
          </auto-complete-master-data-select>
         </div>
        </div>

        <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div class = "inputBox">
          <md-field>
            <label>IBS</label>
            <md-input v-model.trim="searchRequest.ibs"/>
          </md-field>
          </div>
        </div>

      <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
        <div class = "inputBox">
          <auto-complete-master-data-select
                                      group="INBOUND_STATUS"
                                      label="Inbound Status"
                                      :init-value="searchRequest.inboundStatus"
                                      :on-item-changed="handleStatusChanged"
          >
          </auto-complete-master-data-select>
        </div>
      </div>
    

     </div>   
   </md-card-content>   

   <md-card-actions md-alignment="space-between">
    <div v-if="getPermission.ibslist.edit" class="md-layout-item md-size-100 md-small-size-100">
          <callingApiCenter path="/api/w/fsi/GetIBSInbound" :not-display-error="true">      
           
             <md-button class="custMenuButton md-raised" @click="doDownloadExcel" :disabled="!getDownloadCond"> Download </md-button>
             <input
             class="custSearchBar"
             type="text"
             placeholder="Searching Term"
             v-model="searchtermFilter"
             />

             <div class="custButtonRight">
              <md-button class="md-raised custMenuButton md-primary" @click="doSearch">Search</md-button>
              <md-button class="md-raised custMenuButton" @click="doClear">Clear</md-button>
              <md-button class="md-icon-button" @click="mouseLeave" id="expand-button">
                <md-icon v-if="active == false">keyboard_arrow_down</md-icon>
                <md-icon v-if="active == true">keyboard_arrow_up</md-icon>
               </md-button>
             </div>

          </callingApiCenter>
      </div>
  </md-card-actions>
    

 
</md-card>

<pagination :items="getFSIDRToDisplay">
  <template slot-scope="{pageItems}">
    <md-card class="data-table-container">
      <div class="outer-container">
        <div class="inner-container">
          <div class="table-header">
            <table id="headertable">
              <thead>
                <th ></th>

              <th class="header-cell headerCenter w5"
              @click="sortFunction('ibs')">IBS</th>

              <th class="header-cell center w5"
              @click="sortFunction('apptDate')">Appointment Date</th>

              <th class="header-cell center w5"
              @click="sortFunction('apptDate')">Appointment Time</th>

              <th class="header-cell headerCenter w5"
              @click="sortFunction('receivingWindows')">Receiving Windows</th>

              <th class="header-cell headerCenter w5"
              @click="sortFunction('po')">Purchasing Document</th>

              <th class="header-cell headerCenter w5"
              @click="sortFunction('supplier')">Supplier ID</th>

              <th class="header-cell headerCenter w10"
              @click="sortFunction('supplier_name')">Supplier Name</th>

              <th class="header-cell headerCenter w5"
              @click="sortFunction('trucker')">Trucker ID</th>

              <th class="header-cell headerCenter w10"
              @click="sortFunction('truck_name')">Trucker name</th>

              <th class="header-cell headerCenter w5"
              @click="sortFunction('matnr')">Material</th>

              <th class="header-cell center w10"
              v-on:click="sortFunction('matnr_desc')">Material Desc</th>

              </thead>
            </table>
          </div>
          <div class="table-body " @scroll="handleScroll">
            <table id="bodytable">
              <tbody>
                <tr v-for="item in pageItems">
                  <td></td>

                  <td class="body-cell excelBox w5">{{ item.ibs }}</td>  

                  <td class="body-cell excelBox w5">{{ item.apptDate | date }}</td>

                  <td class="body-cell excelBox w5">{{ item.apptDate | time }}</td>       
                  
                  <td class="body-cell excelBox w5">{{ item.receivingWindows }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.po }}</td>                 

                  <td class="body-cell excelBox w5">{{ item.supplier }}</td>
                  
                  <td class="body-cell excelBox w10">{{ item.supplier_name }}</td>
                  
                  <td class="body-cell excelBox w5">{{ item.trucker }}</td>
                  
                  <td class="body-cell excelBox w10">{{ item.trucker_name }}</td>

                  <td class="body-cell excelBox w5">{{ item.matnr }}</td>
                  
                  <td class="body-cell excelBox w10">{{ item.matnr_desc }}</td>

              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </md-card>
  </template>
</pagination>
</div>
</template>


<style scoped>
@import '../../public/chris.css';
.excelBox {
padding-top: 15px;
padding-bottom: 15px;
padding-left: 5px;
padding-right: 5px;
text-align: center;
}
.material-icons.md-18 { font-size: 18px; }
.material-icons.md-24 { font-size: 24px; }
.material-icons.md-36 { font-size: 36px; }
.material-icons.md-48 { font-size: 100px; }
.material-icons.md-light { color: rgba(255, 255, 255, 1); }
.material-icons.md-light.md-inactive { color: rgba(255, 255, 255, 0.3); }
.icons-center {
vertical-align: middle;
margin-right: 10px;
}
.inputBox {
border: 1px solid #cacbcc;
border-radius: 5px;
color: #29303b;
font-size: 18px;
height: auto;
line-height: 1.5em;
padding: 5px 5px 5px 5px;
margin-top: 5px;
}
.inputBox:hover {
border: 2px solid #448aff;
border-radius: 5px;
color: #29303b;
font-size: 18px;
height: auto;
line-height: 1.5em;
padding: 6px 6px 6px 6px;
margin-top: 5px;
background-color: #e0eff7;
  
}
.tableW {
height: 40px;
}
.center {
text-align: center;
}
tr:hover {
background: #c8e6f5;
}
.headerCenter {
text-align: center;
}
.modal {
 background-color: #29303b;
  border-radius: 5px;
}
.modalTitle {
font-weight: normal;
font-family: 'UberMove', 'Open Sans', 'Helvetica Neue', Helvetica, sans-serif !important;
font-weight: 500;
color: white;
font-family: Poppins, sans-serif;
margin-bottom: 0.5rem;
line-height: 1.6;
}
.md-menu {
padding: 0;
padding: 0;
}
.custButton {
margin: 10px;
width: 120px;
height: 40px;
line-height:40px;
font-size: 0.8rem;
}
.custMenuButton {
width: 110px;
height: 40px;
line-height:45px;
font-size: 0.9rem;
align-self: center;
}
.custButtonRight {
  margin: 3px;
  width: 300px;
  height: 40px;
  float: right;
}
.custButtonFilter{
  margin: 5px;
  width: 80px ;
  height: 30px ;
  font-size: 0.7rem ;
}
.custButtonFilterRight {
  margin: 5px;
  width: 200PX;
  height: 40px;
  float: right;
}
.inputBoxSpace {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    width: 200px;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
  }
.inputBoxDouble {
    width: 400px;
    justify-content: space-around;
    display: flex;
  flex-direction: row;
  }
.inputBoxSpaceWide {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    width: 400px;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
  }
  .result-included-outter-div {
    border: 1px solid #D0D0D0;
    border-radius: 5px;
    width: auto;
    padding: 10px;
    height: auto;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 20px;
}
.result-included-inner-div {
    margin-left: 5px;
    font-weight: bold;
    margin-bottom: -25px;
}
.result-included-div-span {
    margin-left: 100px; 
    margin-top: -10px;
}
.result-included-span {
    margin-left: 5px;
}

.result-included-inner-div-radio {
    margin-left: 5px;
    margin-bottom: -25px;
    margin: -12px;
}
.result-included-span-radio {
    font-weight: bold;
    margin-left: 12px;
    margin-right: 12px;
    position:relative;
    top: -5px;
}

</style>

<script>
/* eslint-disable no-plusplus */
import { mapGetters } from 'vuex';
import dateFormat from '../utils/dateFormat';
import api from "../api";
import parseXls from "../utils/parseXls";
import callingApiCenter from "../components/CallingApiCenter.vue";
import sort from "fast-sort";
import toGenerateExcelRequest, { downloadExcel } from "../utils/excel";


const getInitSearch = () => ({
  apptDate: {
    startDate: dateFormat.getLocalDateOnly(moment().startOf('d').toDate()),
   // endDate: dateFormat.getLocalDateEnd(moment().endOf('d').toDate()),
  },
  receivingWindows: null,
  ibs : null,
  ibs_types: [],
  inboundStatus: "N",
});

export default {
data: () => ({
  searchRequest: getInitSearch(),
  active: true,
  // isFilterModalShowing:false,
  FSIDailyreport: [],
  items:[],
  searchtermFilter: "",
  inbound_recwin: [],
}),
components: {
  callingApiCenter,
},
watch: {
  getFSIDailyreport(val) {
    this.updateFSIDR(val);
  },
},
computed: {
...mapGetters([
    'getPermission',
    'getUserProfile',
    'getRole',
    'getFSIDailyreport',
    'getMasterDataByGroup',
  ]),
  getFSIDRToDisplay() {
    return this.FSIDailyreport.filter((row) => {
        const term = this.searchtermFilter.toUpperCase().trim();
        return (
          this.includeNull(row.ibs).includes(term)
        );
      });
    },  
  getDownloadCond() {
       return this.FSIDailyreport.length > 0;
    },

},
async mounted() {
  const cachedSearchRequest = this.searchRequest;
  if (cachedSearchRequest && !_(cachedSearchRequest).isEmpty()) {
    this.searchRequest = JSON.parse(JSON.stringify(cachedSearchRequest));
  } else {
   this.searchRequest = getInitSearch(this);
  }
  console.log(`rec win: ${JSON.stringify(this.getMasterDataByGroup('REC_WINDOW').filter( it => it.tagName != 'STC'))}`);
  this.inbound_recwin = this.getMasterDataByGroup('REC_WINDOW').filter( it => it.tagName != 'STC');

},
 methods: {
    handleStatusChanged(id) {
      this.searchRequest.inboundStatus = id;
   },
   handleWindowsChanged(id) {
      this.searchRequest.receivingWindows = id;
    },
    mouseOver: function(){
      this.active = true;
    },
    mouseLeave: function() {
      this.active = !this.active;
    },
    updateFSIDR(FSIDailyreport) {
      var items = JSON.parse(JSON.stringify(FSIDailyreport));
      this.FSIDailyreport = items;
      
    },
    doSearch() {
    this.active = false;

    console.log("this.ibsoutbound:" + this.searchRequest);
    this.$nextTick(() => {
      this.$store.dispatch('FSIDRList', this.searchRequest);
    })
    },

    doClear() {
    this.$nextTick(() => {
      this.searchRequest = getInitSearch();
    });
    },
    handleScroll(e) {
       $(this.$el.querySelector('.table-header'))
       .offset({
          left: -1 * (e.target.scrollLeft - $('.outer-container')
           .offset().left),
      });
    },
    includeNull(field) {
      return field == null ? "" : field;
    },
    sortFunction(sortFiled){
      const sorted = sort(this.FSIDailyreport).asc(sortFiled);
      this.sortStatus = !this.sortStatus;
      console.log(this.sortStatus)
      console.log(this.FSIDailyreport)
    if (this.sortStatus)
      {
        this.items = sorted;
      }
    else
      {
      this.items = sorted.reverse();
    }
            
    },

    doDownloadExcel(){
       const request = toGenerateExcelRequest(
          this.$el.querySelector('.data-table-container .inner-container'),
          'FSIDailyreport_Noshow.xls',
          1,
        );
        request.heads = _(request.heads).take(request.heads.length);
        request.rows = _(this.getFSIDRToDisplay)
        .map(item => [
            item.ibs,
            dateFormat.date(item.apptDate),
            dateFormat.time(item.apptDate),
            item.receivingWindows,
            item.po,        
            item.supplier,
            item.supplier_name,
            item.trucker,
            item.trucker_name,
            item.matnr,
            item.matnr_desc,

          ]);
        this.$store.dispatch('generateExcel', request)
          .then((res) => {
            window.open(res.url, 'blank');
      });
    },
  }
}
</script>